import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import Typography from "@limitless/modern/data-display/typography/Typography";
const useStyles = makeStyles(theme => ({
  headerContainer: {
    marginBottom: 8
  },
  header: {
    fontSize: "2.125rem",
    letterSpacing: 0.25,
    fontSmoothing: "antialiased"
  },
  subHeader: {
    fontSize: "1rem",
    marginTop: 12,
    fontSmoothing: "antialiased"
  },
  subHeaderText: {
    whiteSpace: "pre-line",
    overflowWrap: "break-word"
  },
  logo: {
    maxWidth: 60
  },
  [theme.breakpoints.up("sm")]: {
    logo: {
      maxWidth: 80
    }
  }
}));
const LLMLandingHeader = ({
  content,
  isLLMVisible
}) => {
  const classes = useStyles();
  const {
    images,
    header,
    subHeader,
    hideLogoAfterSubmit,
    headerVariant,
    subHeaderVariant,
    showAfterSubmitText,
    showAfterSubmit,
    linkText
  } = content;
  const subHeaderArray = linkText && subHeader.includes(linkText) && subHeader.split(linkText);
  const imgSrc = images.find(i => i.size === "large").url;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.headerContainer,
    justifyContent: "space-between",
    wrap: "nowrap"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    direction: "column",
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: headerVariant ? headerVariant : "h4"
  }, !isLLMVisible || showAfterSubmit && !showAfterSubmitText ? header : ""), !linkText || !subHeaderArray ? /*#__PURE__*/React.createElement(Typography, {
    variant: subHeaderVariant ? subHeaderVariant : "body2",
    mt: 2,
    className: classes.subHeaderText
  }, isLLMVisible && showAfterSubmitText ? showAfterSubmitText : subHeader) : subHeaderArray && /*#__PURE__*/React.createElement(Grid, {
    mt: "12px"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: subHeaderVariant ? subHeaderVariant : "body2",
    className: classes.subHeaderText
  }, subHeaderArray[0]), /*#__PURE__*/React.createElement(Typography, {
    variant: subHeaderVariant ? subHeaderVariant : "body2",
    ml: 0.2,
    mr: 0.2,
    color: "primary",
    style: {
      cursor: "pointer"
    },
    onClick: () => window.handleFAQClick && window.handleFAQClick(),
    className: classes.subHeaderText
  }, linkText), /*#__PURE__*/React.createElement(Typography, {
    variant: subHeaderVariant ? subHeaderVariant : "body2",
    className: classes.subHeaderText
  }, subHeaderArray[1]))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, isLLMVisible && hideLogoAfterSubmit ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement("img", {
    src: imgSrc,
    className: classes.logo
  })));
};
export default LLMLandingHeader;
LLMLandingHeader.propTypes = {
  content: PropTypes.object.isRequired,
  isLLMVisible: PropTypes.bool
};